/**
 * Утилиты для работы с партнёрскими ссылками Tripster.
 *
 * Tripster URL имеет вид: https://experience.tripster.ru/experience/<id>/
 * Партнёрские параметры добавляются в query string.
 */

import { shouldSkipUrl } from './trip'

/**
 * Проверяет, является ли URL ссылкой на Tripster
 * @param {string} href
 * @returns {boolean}
 */
export function isTripsterUrl(href) {
  if (!href || typeof href !== 'string') return false
  try {
    const url = new URL(href)
    return url.hostname === 'experience.tripster.ru'
  } catch {
    return false
  }
}

/**
 * Добавляет партнёрские параметры к URL Tripster
 * @param {string} href - Исходный URL
 * @param {string} [utmTerm=''] - Значение utm_term (обычно slug поста)
 * @returns {string} URL с партнёрскими параметрами
 */
export function decorateTripsterUrl(href, utmTerm = '') {
  if (!href || typeof href !== 'string') return href
  if (shouldSkipUrl(href)) return href
  if (!isTripsterUrl(href)) return href

  try {
    const url = new URL(href)
    url.searchParams.set('exp_partner', 'triplinkhub')
    url.searchParams.set('utm_source', 'triplinkhub')
    url.searchParams.set('utm_campaign', 'affiliates')
    url.searchParams.set('utm_medium', 'api')
    if (utmTerm) {
      // Tripster допускает только латиницу, цифры, "-" и "_"
      const sanitized = utmTerm.replace(/[^a-zA-Z0-9_-]/g, '')
      if (sanitized) url.searchParams.set('utm_term', sanitized)
    }
    return url.toString()
  } catch {
    return href
  }
}

/**
 * Строит URL экскурсии Tripster по числовому ID
 * @param {string|number} experienceId - ID экскурсии
 * @returns {string} Полный URL
 */
export function buildTripsterExperienceUrl(experienceId) {
  return `https://experience.tripster.ru/experience/${experienceId}/`
}
